import { useMemo } from "react";

import Stack from "components/Stack";

import SectionHeader from "entities/Memo/components/Sections/SectionHeader";
import { IMemoSection } from "entities/Memo/sdk";
import Table from "entities/TableStorage/components/Table";

interface IPrintableChecklistTable {
  section: IMemoSection;
}

const PrintableChecklistTable = ({ section }: IPrintableChecklistTable) => {
  const initialTableData = useMemo(
    () =>
      section.checklist_table.map((row) => ({
        cells: row.map(({ value, is_editable: isEditable }) => ({
          value,
          isEditable,
        })),
      })),
    [section.checklist_table]
  );

  return (
    <>
      <Stack spacing={2}>
        <SectionHeader label={section.title} alignActionButton="right" />
        <Table
          sx={{
            table: { width: "100%" },
            ...(section.table_section_compact_view
              ? {
                  "tr, td, th, table, tbody": {
                    padding: 0.5,
                    borderTop: 0,
                    borderLeft: 0,
                    borderRight: 0,
                  },
                }
              : {}),
          }}
          tableData={initialTableData}
        />
      </Stack>
    </>
  );
};
export default PrintableChecklistTable;
